import { Injectable } from '@angular/core';

import { AccessToken } from '../../../shared/sdk/models';
import { AppUserApi }  from '../../../shared/sdk/services';


@Injectable()
export class AuthService {

  private userId: number;
  private user: any;
  private accessTokenId: string;

  constructor(private userApi: AppUserApi) {}

  public login(username: string, password: string): Promise<any> {

    return new Promise((resolve, reject) => {

      this.userApi.login({username: username, password: password}, {}, true)
        .map((res:any) => res.json())
        .subscribe(
          (data) => {
            let token: AccessToken = data.token;
            if (token.userId != null) {
              this.userId = token.userId;
              this.accessTokenId = token.id;
              this.user = token.user;
              resolve();
            }
            else {
              reject();
            }
          },
          (error: any) => {
            reject(error);
          }
        );

    });

  }

  public logout() : Promise<any> {

    return new Promise((resolve, reject) => {
      this.userApi.logout().subscribe(() => {
        resolve();
      });
    });

  }

  public loggedIn(): boolean {

    return this.userApi.isAuthenticated();

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/login/common/auth.service.ts